import { Field, useFormikContext } from "formik";
import { FC } from "react";
import { useLocale } from "@/contexts/localeContext";
import { TranslationKeys } from "@/contexts/TranslationKeys";
import DateField from "@/components/date-field/date-field";
import Label from "@/components/label/label";
import Togglebox from "@/components/togglebox/togglebox";
import { WizardStepLayout } from '@/components/wizard/wizard-summary-layout';
import { requiredValidation } from "@/utilities/Validation";
import { ASSIGNING_TYPE } from "@/constants/expiry-reason-constant";

interface StartDateProps {
    assigningType: ASSIGNING_TYPE
    idPath: string;
    originalSelectedRows: any[];
    onBack: (event: any) => void | undefined;
    onNext: (event: any) => void | undefined;
}

const DetailStep: FC<StartDateProps> = ({ onNext, onBack, originalSelectedRows, assigningType, idPath }) => {
    const { translate } = useLocale();
    const { values, errors } = useFormikContext<any>();
    const selectedRows = values.selectedRows || [];
    const toBeAssignedRows = selectedRows.filter((row: any) => !originalSelectedRows.some((original: any) => original[idPath] === row.id.toString()));

    const isStepValid = (): boolean => {
        if (values.useSameDate || assigningType == "MEMBERS") {
            return values.startDate;
        }

        return toBeAssignedRows.every(reason => values[`startDate_${reason.id}`]);
    }

    return <WizardStepLayout onBack={onBack} onNext={onNext} nextDisabled={!isStepValid()}>
        <div>
        <div className="text-portal-blue-primary-shade2 pb-1 text-xl font-semibold">
            {translate.byKey(TranslationKeys.details)}
        </div>
        <div className="overflow-y-auto space-y-1" style={{ maxHeight: '340px' }}>
            {assigningType !== "MEMBERS" &&
            <div className="flex flex-col pb-2">
                <Label
                    htmlFor="useSameDate"
                    className="text-sm pt-1">{"Use Same Date"}</Label>
                <Togglebox name="useSameDate" label="" cyName="useSameDate_toggle" />
            </div>}
            {values.useSameDate || assigningType === "MEMBERS" ?
                <div className="flex flex-col" id={`startDatePicker`}>
                    <Label
                        htmlFor={`startDate`}
                        className="text-xs text-gray-600 mt-1"
                        required> {translate.byKey(TranslationKeys.startDate)}:
                    </Label>
                    <Field
                        name={`startDate`}
                        component={DateField}
                        valueName={`startDate`}
                        validate={(value) => requiredValidation(value, translate)}/>
                </div> :
                <div className="flex flex-col space-y-2">
                    {toBeAssignedRows.map(reason => (
                        <div className="flex flex-col">
                            <div className="flex flex-row justify-between" id={`startDateLabel_${reason.id}`}>
                                <Label
                                    htmlFor={`startDate_${reason.id}`}
                                    className="text-xs text-gray-600 mt-1"
                                    required> {`${reason.name} Start Date`}:
                                </Label>
                                {errors[`startDate_${reason.id}`] ? <span className="">{errors[`startDate_${reason.id}`]}</span> : null}
                            </div>
                            <Field
                                name={`startDate_${reason.id}`}
                                component={DateField}
                                valueName={`startDate_${reason.id}`}
                                validate={(value) => requiredValidation(value, translate)}
                                dataCy = "startDatePicker"  />
                        </div>
                    ))}
                </div>}
        </div>
        </div>
    </WizardStepLayout>
};

export default DetailStep;